import { rememberPlan } from '../../../premium/billingIntent';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FiCheck, FiLock, FiUser, FiLayout, FiUsers, FiSearch, FiEye, FiSliders, FiTarget, FiMessageCircle, FiAward, FiTrendingUp } from 'react-icons/fi';
import copy from './pricingTranslations.json';
import './PricingSection.css';

const featureIcons = [FiUser, FiLayout, FiUsers, FiSearch, FiEye, FiSliders, FiTarget, FiMessageCircle, FiAward, FiTrendingUp];

export default function PricingSection() {
  const { i18n } = useTranslation();
  const language = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];
  const text = copy[language] || copy.en;
  const [yearly, setYearly] = useState(true);
  const price = (value) => new Intl.NumberFormat(language, { style: 'currency', currency: 'EUR', maximumFractionDigits: value % 1 ? 2 : 0 }).format(value);

  return (
    <section className="wb-pricing" id="pricing" dir={language === 'ar' ? 'rtl' : 'ltr'} aria-labelledby="wb-pricing-title">
      <div className="wb-pricing-shell">
        <header className="wb-pricing-heading">
          <span className="wb-pricing-eyebrow">{text.eyebrow}</span>
          <h2 id="wb-pricing-title">{text.title}</h2>
          <p>{text.lead}</p>
        </header>
        <div className="wb-pricing-switch" role="group" aria-label={text.billing}>
          <button type="button" aria-pressed={!yearly} onClick={() => setYearly(false)}>{text.monthly}</button>
          <button type="button" aria-pressed={yearly} onClick={() => setYearly(true)}>{text.yearly}<span>{text.saving}</span></button>
        </div>
        <div className="wb-pricing-cards">
          {[false, true].map((premium) => (
            <article key={String(premium)} className={`wb-pricing-card${premium ? ' wb-pricing-premium' : ''}`}>
              <div className="wb-pricing-plan"><span className="wb-pricing-plan-icon">{premium ? <FiAward aria-hidden="true" /> : <FiUser aria-hidden="true" />}</span><h3>{premium ? 'Premium' : 'Free'}</h3>{premium && <span className="wb-pricing-tag">{text.premiumTag}</span>}</div>
              <p className="wb-pricing-description">{premium ? text.premiumDescription : text.freeDescription}</p>
              <div className="wb-pricing-price" aria-live="polite" aria-atomic="true"><strong><bdi>{price(premium ? (yearly ? 199 : 19.99) : 0)}</bdi></strong><span>{premium ? (yearly ? text.perYear : text.perMonth) : text.forever}</span></div>
              <p className="wb-pricing-billing">{premium ? (yearly ? text.yearlyBilling : text.monthlyBilling) : text.freeBilling}</p>
              <Link className="wb-pricing-cta" to={sessionStorage.getItem("token") && premium ? "/billing" : "/register"} onClick={() => rememberPlan(premium ? (yearly ? "yearly" : "monthly") : null)}>{text.start}</Link>
              <ul className="wb-pricing-features">
                {text.features.map((feature, index) => {
                  const Icon = featureIcons[index];
                  const included = premium || index < 4;
                  return <li key={index} className={included ? '' : 'wb-pricing-locked'}><Icon className="wb-pricing-feature-icon" aria-hidden="true" /><span>{feature}</span><span className="wb-pricing-status" role="img" aria-label={included ? text.included : text.premiumOnly}>{included ? <FiCheck aria-hidden="true" /> : <FiLock aria-hidden="true" />}</span></li>;
                })}
              </ul>
            </article>
          ))}
        </div>
        <p className="wb-pricing-note">{text.currency}</p>
      </div>
    </section>
  );
}
